// extracted by mini-css-extract-plugin
export var gif = "_k8-0";